import { create } from 'zustand';

export interface RiderOrdersDialogTarget {
  riderId: number;
  riderName?: string | null;
  /** When set, restricts the staff orders list to this store (e.g. store roster). */
  storeId?: number | null;
}

interface RiderOrdersDialogState {
  open: boolean;
  target: RiderOrdersDialogTarget | null;
  openRiderOrders: (t: RiderOrdersDialogTarget) => void;
  closeRiderOrders: () => void;
}

export const useRiderOrdersDialogStore = create<RiderOrdersDialogState>((set) => ({
  open: false,
  target: null,
  openRiderOrders: (t) => set({ open: true, target: t }),
  closeRiderOrders: () => set({ open: false, target: null }),
}));

export function openRiderOrders(t: RiderOrdersDialogTarget) {
  useRiderOrdersDialogStore.getState().openRiderOrders(t);
}

export function closeRiderOrders() {
  useRiderOrdersDialogStore.getState().closeRiderOrders();
}
